import React from 'react';
import ReactQueryParams from "react-query-params";
import {Col, Button, Row, Card, CardBody, Badge, ButtonToolbar, Container} from 'reactstrap';

import * as TextManager from "../../../modules/languages/TextManager";
import * as environment from "../../../modules/environment";
import {Link, withRouter} from 'react-router-dom';
import {connect} from "react-redux";
import * as http from '../../../modules/http';
import Alert from '../../../components/Alert';
import CheckBox from "../../../components/CheckBox";
import Modal from './Modal'
import Modal2 from '../../../components/Modal'
import StoreOrdersTable from "./StoreOrdersTable"
import {fetchSalesDataIfNeeded} from "../../../redux/actions/SalesActions";
import MaterialTable from '../../../components/table/material_table/MaterialTable'
import {fetchProvidersDataIfNeeded} from "../../../redux/actions/ProvidersActions";
import {fetchOrdersDataForce} from "../../../redux/actions/OrdersActions"

class OrderForm extends ReactQueryParams {
    constructor(props) {
        super(props);
        this.state = {
            order: '',
            warning: '',
            error: false,
            saved: false,
            success: false,
        };
    }

    componentDidMount() {
        this.props.dispatch(fetchSalesDataIfNeeded());
        this.props.dispatch(fetchProvidersDataIfNeeded());
    }

    chooseProvider = (id, e) => {
        let tmp = this.state.order.split(',');

        if (e === true) {
            if (!tmp.includes(id.toString())) {
                let ids = this.state.order;
                if (ids === "")
                    this.setState({order: id.toString()});
                else
                    this.setState({order: ids.concat("," + id.toString())});
            }
        }
        else {
            if (tmp.includes(id.toString())) {
                let res = "";
                let idString = id.toString();
                for (let index in tmp) {
                    if (idString !== tmp[index]) {
                        if (res === "")
                            res += tmp[index];
                        else
                            res += "," + tmp[index];
                    }
                }

                this.setState({order: res});
            }
        }
    };

    sendOrder = () => {

        if(this.state.order === '') {
            this.setState({warning: TextManager.getCurrentTextResource().Text.pleaseSelectProvider});
            return;
        }

        this.setState({saving: true, error: false, warning: ''});

        const storeData = {
            storeId: this.props.userData.data.id,
            order: this.state.order
        };

        http.postToServer(
            'order/new',
            storeData,
            (response) => {
                this.setState({saving: false, error: false, success: true, order: ''});

                this.props.dispatch(fetchOrdersDataForce(this.queryParams));
            },
            (response) => {
                console.warn('error storing', response);
                this.setState({saving: false, error: true})
            }
        );
    };

    buildMetaTable = () => {
        let res = {name: 'הזמנות', metrics: []};

        res.metrics.push({
            id: 'day',
            label: 'תאריך הזמנה',
            numeric: false,
            disablePadding: true
        });

        res.metrics.push({
            id: 'orders',
            label: 'פרטי הזמנה',
            numeric: false,
            disablePadding: true
        });

        res.metrics.push({
            id: 'updateDay',
            label: 'תאריך טיפול',
            numeric: false,
            disablePadding: true
        });

        res.metrics.push({
            id: 'status',
            label: 'סטטוס',
            numeric: false,
            disablePadding: true
        });

        res.metrics.reverse();
        return res;
    };

    buildDataTable = () => {
        let res = [];

        if(this.props.orders && this.props.providers && this.props.providers.length > 0) {

            if(this.props.userData.data.id === 548 || this.props.userData.data.id === 683) {
                this.props.orders.filter(e => (e.storeId === 548 || e.storeId === 683)).map(e =>
                    res.push({
                        'day': e.day,
                        'orders': e.orders.map(a =>
                            " ; " + this.props.providers.find(y => y.id === a.provider).name
                        ),
                        'updateDay': e.updateDay,
                        'status': e.updateDay === '' ? 0 : 1
                    })
                )
            }
            else {
                this.props.orders.filter(e => e.storeId === this.props.userData.data.id).map(e =>
                    res.push({
                        'day': e.day,
                        'orders': e.orders.map(a =>
                            " ; " + this.props.providers.find(y => y.id === a.provider).name
                        ),
                        'updateDay': e.updateDay,
                        'status': e.updateDay === '' ? 0 : 1
                    })
                )
            }
        }
        return res;
    };

    getStatus = (status) => {
        return TextManager.getCurrentTextResource().Text.new;
    };

    getStatusColor = (status) => {
        if (status === 1)
            return "success";
        else
            return "danger";
    };

    /*getCustomComponent = (item, value) => {
        switch (item) {
            case 'status':
                return <div style={{display: 'flex', justifyContent: 'flex-end', alignItems: 'center'}}>
                    <Badge color={this.getStatusColor(value)}
                    >{this.getStatus(value)}</Badge>
                </div>;

            default:
                return <span></span>
        }
    };*/

    render() {

        /*let providers = [];
        if(this.props.data) {
            providers = this.props.data;
        }*/

        let cellular = [];
        let cellularKasher = [];
        if(this.props.data) {
            cellular = this.props.data.filter(a => a.providerType === 1);
            cellularKasher = this.props.data.filter(a => a.providerType === 4);
        }

        let chosenAcc = this.state.order.split(',');

        return(
        <Container className="catalog-items__wrap">
            <style>
                {`
                        .card-body {
                        box-shadow: 0 10px 30px 1px rgba(0, 0, 0, 0.06);
                        }
                    `}
            </style>
            {this.state.warning !== '' &&
            <Row >
                <Alert color='warning' className='alert--bordered' icon >
                    <p><span style={{float: 'right'}}
                             className='bold-text'>{this.state.warning}</span>
                    </p>
                </Alert>
            </Row>}
            {this.state.error &&
            <Row>
                <Alert color='danger' className='alert--bordered' icon>
                    <p><span className='bold-text'>{TextManager.getCurrentTextResource().Text.error}</span></p>
                    <p>{TextManager.getCurrentTextResource().Text.unexpectedServerError}</p>
                </Alert>
            </Row>
            }
            {this.state.success &&
            <Modal2 color='success' title={TextManager.getCurrentTextResource().Text.wellDone} noCancel
                    message={TextManager.getCurrentTextResource().Text.orderSucceeded}
                    approve={() => this.setState({saved: true, success: false})}/>
            }

            {cellular && cellular.length > 0 && <Row style={{ fontSize: '30px'}}>סלולר רגיל</Row>}
            {cellular && cellular.length > 0 && <Row>
                <div className="catalog-items">
                    {cellular.map((item, i) => {
                        let res = chosenAcc.includes((item.id).toString());
                        return(
                        <div className="catalog-item" key={i}
                             style={{marginBottom: '5px', marginRight: '3px', marginLeft: '3px'}}>
                            <div className="catalog-item__link">
                                <div className="catalog-item__info">
                                    <h5 className="catalog-item__title"
                                        style={{fontWeight: 'bold', textAlign: 'center'}}>{item.name}</h5>
                                </div>
                                <div className="catalog-item__img-wrap">
                                    <img className="catalog-item__img" style={{objectFit: 'contain'}}
                                         src={environment.getServerBasePath() + '/providers/download?providerID=' + item.id}
                                         alt="catalog-item-img"/>
                                </div>
                                <div className="catalog-item__info" style={{display: 'flex', margin: '0 10px', padding: '10px 0 10px 28px', position: 'relative'}}>
                                    <CheckBox
                                        label='להזמין'
                                        name={item.name}
                                        value={res}
                                        onChange={(e) => this.chooseProvider(item.id, e)}/>
                                </div>
                            </div>
                        </div>)
                    })}
                </div>
            </Row>}

            {cellularKasher && cellularKasher.length > 0 && <Row style={{ fontSize: '30px'}}>סלולר כשר</Row>}
            {cellularKasher && cellularKasher.length > 0 && <Row>
                <div className="catalog-items">
                    {cellularKasher.map((item, i) => {
                        let res = chosenAcc.includes((item.id).toString());
                        return(
                        <div className="catalog-item" key={i}
                             style={{marginBottom: '5px', marginRight: '3px', marginLeft: '3px'}}>
                            <div className="catalog-item__link">
                                <div className="catalog-item__info">
                                    <h5 className="catalog-item__title"
                                        style={{fontWeight: 'bold', textAlign: 'center'}}>{item.name}</h5>
                                </div>
                                <div className="catalog-item__img-wrap">
                                    <img className="catalog-item__img" style={{objectFit: 'contain'}}
                                         src={environment.getServerBasePath() + '/providers/download?providerID=' + item.id}
                                         alt="catalog-item-img"/>
                                </div>
                                <div className="catalog-item__info" style={{display: 'flex', margin: '0 10px', padding: '10px 0 10px 28px', position: 'relative'}}>
                                    <CheckBox
                                        label='להזמין'
                                        name={item.name}
                                        value={res}
                                        onChange={(e) => this.chooseProvider(item.id, e)}/>
                                </div>
                            </div>
                        </div>
                        )
                    })}
                </div>
            </Row>}

            <Row>
                <Modal color='primary' title='Are you sure!'
                       approve={() => this.sendOrder()}
                       message={'?' + TextManager.getCurrentTextResource().Text.makeOrder}>
                    <ButtonToolbar className="form__button-toolbar" style={{flexDirection: 'row-reverse', padding: '15px'}}>
                        <Button color='primary' onClick={(e) => e.preventDefault()}>
                            {TextManager.getCurrentTextResource().Text.makeOrder}
                        </Button>
                    </ButtonToolbar>
                </Modal>
            </Row>

            <Row>
                {/*<MaterialTable data={this.buildDataTable()} noPaddingCard
                               meta={this.buildMetaTable()}
                               customFields={['status']} getCustomComponent={this.getCustomComponent}/>*/}
                <StoreOrdersTable data={this.buildDataTable()}/>

            </Row>

        </Container>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        data: state.sales.data,
        orders: state.orders.data.orders,
        status: state.sales.status,
        userData: state.userData,
        providers: state.providers.data
    };
};

export default withRouter(connect(mapStateToProps)(OrderForm))